import { render, staticRenderFns } from "./ddLogin.vue?vue&type=template&id=4a511eba&scoped=true&"
import script from "./ddLogin.vue?vue&type=script&lang=js&"
export * from "./ddLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a511eba",
  null
  
)

export default component.exports